import {ICompanySyncstep} from "../../../../../index";
import {getObjectDefinition} from "../../../../../util/misc";
import {ObjectTypeId} from "../../../../../constants";
import {ICompositeCompanySyncstepFilter} from ".";
import detailsHtml from './details.html?raw';

export const template = detailsHtml;

interface IParams {
    companysyncstep: ICompanySyncstep
}

export class viewModel {
    private companysyncstep: ICompanySyncstep

    constructor(params: IParams) {
        this.companysyncstep = params.companysyncstep
    }

    private getSorted(): ICompositeCompanySyncstepFilter[] {
        return [
            ObjectTypeId.User,
            ObjectTypeId.Department,
            ObjectTypeId.Group,
        ].map(objectTypeId => {
            const objDef = getObjectDefinition(objectTypeId)
            const filter =  this.companysyncstep.filters.find(f => f.objecttypeid == objectTypeId) ?? null
            return {
                filter: filter,
                objDef: objDef,
                objectTypeId: objectTypeId,
                icon: !!filter ? 'fa-check-circle': 'fa-minus-circle',
                iconCls: !!filter ? 'text-success' : 'text-muted',
            }
        })
    }
}